var map = {
	"./cancellationPolicy.md": [
		7385,
		7385
	],
	"./faq/UAECorporateTaxImplications.md": [
		8636,
		8636
	],
	"./faq/bankStatementProcessing.md": [
		1393,
		1393
	],
	"./faq/bestAccountingSoftwareUAE.md": [
		4562,
		4562
	],
	"./faq/determinationOfTaxableIncome.md": [
		7933,
		7933
	],
	"./faq/referal.md": [
		2406,
		2406
	],
	"./faq/smallBusinessReliefGuide.md": [
		1457,
		1457
	],
	"./integrations.md": [
		687,
		687
	],
	"./pricingPlans.md": [
		1650,
		1650
	],
	"./sahlCookiesPolicy.md": [
		3187,
		3187
	],
	"./sahlPrivacyAndSecurityPolicy.md": [
		9865,
		9865
	],
	"./sahlTermsOfService.md": [
		4805,
		4805
	],
	"./welcome.md": [
		3994,
		3994
	],
	"./whySahlTax.md": [
		9899,
		9899
	],
	"./whySahlTaxVsAgencies.md": [
		6283,
		6283
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9748;
module.exports = webpackAsyncContext;